export default __webpack_public_path__ + "1413d05b429f0d8668028bfb93f65537.png";